import type { GuardianPlayerSession } from '@/features/guardian-player/services';
import { formatGuardianApiDate, parseGuardianApiDate } from '@/features/guardian-player/utils';
import { format } from 'date-fns';

export type SessionHistoryListDataItem =
  | { kind: 'month'; id: string; label: string }
  | {
      kind: 'session';
      id: string;
      session: GuardianPlayerSession;
      dateParts: SessionHistoryDateParts;
    };

export type SessionHistoryDateParts = {
  month: string;
  weekday: string;
  day: string;
};

export function formatSessionHistoryStartDate(raw?: string) {
  return formatGuardianApiDate(raw, 'MMM yyyy');
}

export function getSessionHistoryDateParts(raw: string): SessionHistoryDateParts {
  const date = parseGuardianApiDate(raw);

  if (!date) {
    return {
      month: '',
      weekday: '',
      day: '-',
    };
  }

  return {
    month: format(date, 'MMM yyyy'),
    weekday: format(date, 'EEE'),
    day: format(date, 'd'),
  };
}

export function buildSessionHistoryListItems(
  sessions: readonly GuardianPlayerSession[],
): SessionHistoryListDataItem[] {
  const sortedSessions = [...sessions].sort((a, b) => b.date.localeCompare(a.date));
  const items: SessionHistoryListDataItem[] = [];
  let currentMonth = '';

  sortedSessions.forEach(session => {
    const dateParts = getSessionHistoryDateParts(session.date);
    const month = dateParts.month;

    if (month !== currentMonth) {
      currentMonth = month;
      items.push({ kind: 'month', id: `month-${month}`, label: month });
    }

    items.push({ kind: 'session', id: session.id, session, dateParts });
  });

  return items;
}
